import { render, staticRenderFns } from "./HomeSections.vue?vue&type=template&id=94b4ca92&scoped=true&"
import script from "./HomeSections.vue?vue&type=script&lang=js&"
export * from "./HomeSections.vue?vue&type=script&lang=js&"
import style0 from "./HomeSections.vue?vue&type=style&index=0&id=94b4ca92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b4ca92",
  null
  
)

export default component.exports